import LoadingSpinner from '@/components/LoadingSpinner';

// Rendered by React Router while the initial route loaders / lazy modules resolve on first
// load, so the user sees a spinner instead of a blank screen (and the "No `HydrateFallback`
// element provided" warning goes away).
const RouteHydrateFallback = () => (
  <div
    className="flex h-screen w-full items-center justify-center"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <LoadingSpinner />
    <span className="sr-only">Loading…</span>
  </div>
);

export default RouteHydrateFallback;
